module.exports = __webpack_public_path__ + "static/img/bg.d37b0ca9.png";